// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-agent-panel {
  position: relative;
  padding: 0;
  transition: all 0.3s ease;
}

/* Header */
.ai-agent-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--spacing-lg);
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s ease;
}

.ai-agent-panel.expanded .ai-agent-header {
  border-bottom: 1px solid var(--border-color);
}

.ai-agent-header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.ai-agent-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.ai-agent-icon svg {
  width: 18px;
  height: 18px;
}

.ai-agent-title-group {
  display: flex;
  flex-direction: column;
}

.ai-agent-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.2;
}

.ai-agent-subtitle {
  font-size: 0.7rem;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 4px;
}

.ai-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.ai-status-dot.healthy {
  background: #22c55e;
  box-shadow: 0 0 4px rgba(34, 197, 94, 0.5);
}

.ai-status-dot.fallback {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
}

.ai-status-dot.degraded {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
  animation: degradedDotPulse 1.5s ease-in-out infinite;
}

@keyframes degradedDotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.ai-status-dot.error {
  background: #ef4444;
}

.ai-agent-header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.ai-agent-toggle {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
}

.ai-agent-panel.expanded .ai-agent-toggle {
  transform: rotate(180deg);
}

.ai-refresh-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
}

.ai-refresh-btn:hover {
  background: rgba(99, 102, 241, 0.1);
  border-color: #6366f1;
  color: #6366f1;
}

.ai-refresh-btn.loading {
  opacity: 0.6;
  pointer-events: none;
}

.ai-refresh-btn.loading .icon {
  animation: spin 1s linear infinite;
}

/* Body */
.ai-agent-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.3s ease;
  padding: 0 var(--spacing-lg);
}

.ai-agent-panel.expanded .ai-agent-body {
  max-height: 800px;
  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);
}

/* Loading */
.ai-loading {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--text-secondary);
  font-size: 0.85rem;
  padding: var(--spacing-md) 0;
}

.ai-loading-dots {
  display: flex;
  gap: 4px;
}

.ai-loading-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6366f1;
  animation: aiDotPulse 1.4s ease-in-out infinite;
}

.ai-loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.ai-loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes aiDotPulse {
  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
  40% { opacity: 1; transform: scale(1); }
}

/* Briefing */
.ai-briefing {
  background: rgba(99, 102, 241, 0.06);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  margin-bottom: var(--spacing-md);
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-primary);
}

.ai-briefing-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6366f1;
  margin-bottom: 6px;
}

/* Alerts */
.ai-alerts {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-md);
}

.ai-alerts-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  margin-bottom: 2px;
}

.ai-alert-item {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  line-height: 1.4;
}

.ai-alert-item.critical {
  background: rgba(239, 68, 68, 0.08);
  border-left: 3px solid #ef4444;
  color: #fca5a5;
}

.ai-alert-item.warning {
  background: rgba(245, 158, 11, 0.08);
  border-left: 3px solid #f59e0b;
  color: #fcd34d;
}

.ai-alert-item.info {
  background: rgba(59, 130, 246, 0.08);
  border-left: 3px solid #3b82f6;
  color: #93c5fd;
}

.ai-alert-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.ai-alert-content {
  flex: 1 1;
}

.ai-alert-title {
  font-weight: 600;
  margin-bottom: 2px;
}

.ai-alert-message {
  opacity: 0.85;
  font-size: 0.75rem;
}

.ai-no-alerts {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: rgba(34, 197, 94, 0.08);
  border-radius: var(--radius-sm);
  color: #86efac;
  font-size: 0.8rem;
}

/* Recommendations */
.ai-recommendations {
  margin-bottom: var(--spacing-sm);
}

.ai-recommendations-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-sm);
}

.ai-rec-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ai-rec-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: 20px;
  font-size: 0.75rem;
  color: var(--text-primary);
}

.ai-rec-item .rec-icon {
  font-size: 0.8rem;
}

/* Error state */
.ai-error {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  background: rgba(239, 68, 68, 0.08);
  border-radius: var(--radius-sm);
  color: #fca5a5;
  font-size: 0.8rem;
}

/* Footer */
.ai-agent-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--border-color);
  font-size: 0.65rem;
  color: var(--text-secondary);
  opacity: 0.7;
}

/* Collapsed preview */
.ai-collapsed-preview {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: 0 var(--spacing-lg) var(--spacing-sm);
}

.ai-collapsed-alert-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 600;
}

.ai-collapsed-alert-count.has-alerts {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}

.ai-collapsed-alert-count.no-alerts {
  background: rgba(34, 197, 94, 0.1);
  color: #86efac;
}

.ai-collapsed-briefing {
  font-size: 0.75rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}

/* Budget-exceeded icon pulse */
.ai-agent-icon.budget-warn {
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  animation: budgetPulse 2s ease-in-out infinite;
}

@keyframes budgetPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

/* Cost / Budget section */
.ai-cost-section {
  margin-top: var(--spacing-md);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--border-color);
}

.ai-cost-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.ai-cost-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
}

.ai-cost-value {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-primary);
  font-family: 'SF Mono', 'Fira Code', monospace;
}

.ai-cost-bar-bg {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 6px;
}

.ai-cost-bar-fill {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #22c55e, #4ade80);
  transition: width 0.5s ease;
  min-width: 2px;
}

.ai-cost-bar-fill.warning {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.ai-cost-bar-fill.critical {
  background: linear-gradient(90deg, #ef4444, #f87171);
  animation: costBarPulse 1.5s ease-in-out infinite;
}

@keyframes costBarPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.ai-cost-details {
  display: flex;
  justify-content: space-between;
  font-size: 0.65rem;
  color: var(--text-secondary);
  opacity: 0.8;
}

.ai-budget-warning {
  margin-top: var(--spacing-sm);
  padding: 6px 10px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  color: #fcd34d;
  text-align: center;
}

/* Status dot for budget_exceeded */
.ai-status-dot.budget_exceeded {
  background: #f59e0b;
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);
  animation: budgetDotPulse 1.5s ease-in-out infinite;
}

@keyframes budgetDotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

/* Fallback error notice */
.ai-fallback-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: var(--spacing-sm);
  padding: 6px 10px;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: var(--radius-sm);
  font-size: 0.7rem;
  color: #fcd34d;
  line-height: 1.4;
}

.ai-fallback-error-icon {
  flex-shrink: 0;
}

.ai-fallback-error-text {
  word-break: break-word;
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/AIWeatherAgent/AIWeatherAgent.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,8DAA8D;AAChE;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB,YAAY,EAAE,qBAAqB,EAAE;EACrD,MAAM,UAAU,EAAE,mBAAmB,EAAE;AACzC;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA,+BAA+B;AAC/B;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".ai-agent-panel {\n  position: relative;\n  padding: 0;\n  transition: all 0.3s ease;\n}\n\n/* Header */\n.ai-agent-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md) var(--spacing-lg);\n  cursor: pointer;\n  user-select: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.2s ease;\n}\n\n.ai-agent-panel.expanded .ai-agent-header {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.ai-agent-header-left {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.ai-agent-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.ai-agent-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.ai-agent-title-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.ai-agent-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.ai-agent-subtitle {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ai-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.ai-status-dot.healthy {\n  background: #22c55e;\n  box-shadow: 0 0 4px rgba(34, 197, 94, 0.5);\n}\n\n.ai-status-dot.fallback {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n}\n\n.ai-status-dot.degraded {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n  animation: degradedDotPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes degradedDotPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.ai-status-dot.error {\n  background: #ef4444;\n}\n\n.ai-agent-header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.ai-agent-toggle {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  transition: transform 0.3s ease;\n}\n\n.ai-agent-panel.expanded .ai-agent-toggle {\n  transform: rotate(180deg);\n}\n\n.ai-refresh-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  font-size: 0.7rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s ease;\n}\n\n.ai-refresh-btn:hover {\n  background: rgba(99, 102, 241, 0.1);\n  border-color: #6366f1;\n  color: #6366f1;\n}\n\n.ai-refresh-btn.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.ai-refresh-btn.loading .icon {\n  animation: spin 1s linear infinite;\n}\n\n/* Body */\n.ai-agent-body {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.4s ease, padding 0.3s ease;\n  padding: 0 var(--spacing-lg);\n}\n\n.ai-agent-panel.expanded .ai-agent-body {\n  max-height: 800px;\n  padding: var(--spacing-md) var(--spacing-lg) var(--spacing-lg);\n}\n\n/* Loading */\n.ai-loading {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  padding: var(--spacing-md) 0;\n}\n\n.ai-loading-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.ai-loading-dots span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #6366f1;\n  animation: aiDotPulse 1.4s ease-in-out infinite;\n}\n\n.ai-loading-dots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.ai-loading-dots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes aiDotPulse {\n  0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }\n  40% { opacity: 1; transform: scale(1); }\n}\n\n/* Briefing */\n.ai-briefing {\n  background: rgba(99, 102, 241, 0.06);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n  margin-bottom: var(--spacing-md);\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: var(--text-primary);\n}\n\n.ai-briefing-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6366f1;\n  margin-bottom: 6px;\n}\n\n/* Alerts */\n.ai-alerts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-md);\n}\n\n.ai-alerts-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  margin-bottom: 2px;\n}\n\n.ai-alert-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.ai-alert-item.critical {\n  background: rgba(239, 68, 68, 0.08);\n  border-left: 3px solid #ef4444;\n  color: #fca5a5;\n}\n\n.ai-alert-item.warning {\n  background: rgba(245, 158, 11, 0.08);\n  border-left: 3px solid #f59e0b;\n  color: #fcd34d;\n}\n\n.ai-alert-item.info {\n  background: rgba(59, 130, 246, 0.08);\n  border-left: 3px solid #3b82f6;\n  color: #93c5fd;\n}\n\n.ai-alert-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.ai-alert-content {\n  flex: 1;\n}\n\n.ai-alert-title {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.ai-alert-message {\n  opacity: 0.85;\n  font-size: 0.75rem;\n}\n\n.ai-no-alerts {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: rgba(34, 197, 94, 0.08);\n  border-radius: var(--radius-sm);\n  color: #86efac;\n  font-size: 0.8rem;\n}\n\n/* Recommendations */\n.ai-recommendations {\n  margin-bottom: var(--spacing-sm);\n}\n\n.ai-recommendations-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.ai-rec-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ai-rec-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  background: rgba(99, 102, 241, 0.08);\n  border: 1px solid rgba(99, 102, 241, 0.15);\n  border-radius: 20px;\n  font-size: 0.75rem;\n  color: var(--text-primary);\n}\n\n.ai-rec-item .rec-icon {\n  font-size: 0.8rem;\n}\n\n/* Error state */\n.ai-error {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md);\n  background: rgba(239, 68, 68, 0.08);\n  border-radius: var(--radius-sm);\n  color: #fca5a5;\n  font-size: 0.8rem;\n}\n\n/* Footer */\n.ai-agent-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: var(--spacing-md);\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--border-color);\n  font-size: 0.65rem;\n  color: var(--text-secondary);\n  opacity: 0.7;\n}\n\n/* Collapsed preview */\n.ai-collapsed-preview {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: 0 var(--spacing-lg) var(--spacing-sm);\n}\n\n.ai-collapsed-alert-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.ai-collapsed-alert-count.has-alerts {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n}\n\n.ai-collapsed-alert-count.no-alerts {\n  background: rgba(34, 197, 94, 0.1);\n  color: #86efac;\n}\n\n.ai-collapsed-briefing {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n/* Budget-exceeded icon pulse */\n.ai-agent-icon.budget-warn {\n  background: linear-gradient(135deg, #f59e0b, #ef4444);\n  animation: budgetPulse 2s ease-in-out infinite;\n}\n\n@keyframes budgetPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n/* Cost / Budget section */\n.ai-cost-section {\n  margin-top: var(--spacing-md);\n  padding-top: var(--spacing-md);\n  border-top: 1px solid var(--border-color);\n}\n\n.ai-cost-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.ai-cost-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n}\n\n.ai-cost-value {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  font-family: 'SF Mono', 'Fira Code', monospace;\n}\n\n.ai-cost-bar-bg {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n\n.ai-cost-bar-fill {\n  height: 100%;\n  border-radius: 3px;\n  background: linear-gradient(90deg, #22c55e, #4ade80);\n  transition: width 0.5s ease;\n  min-width: 2px;\n}\n\n.ai-cost-bar-fill.warning {\n  background: linear-gradient(90deg, #f59e0b, #fbbf24);\n}\n\n.ai-cost-bar-fill.critical {\n  background: linear-gradient(90deg, #ef4444, #f87171);\n  animation: costBarPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes costBarPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.ai-cost-details {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.65rem;\n  color: var(--text-secondary);\n  opacity: 0.8;\n}\n\n.ai-budget-warning {\n  margin-top: var(--spacing-sm);\n  padding: 6px 10px;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  color: #fcd34d;\n  text-align: center;\n}\n\n/* Status dot for budget_exceeded */\n.ai-status-dot.budget_exceeded {\n  background: #f59e0b;\n  box-shadow: 0 0 4px rgba(245, 158, 11, 0.5);\n  animation: budgetDotPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes budgetDotPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n/* Fallback error notice */\n.ai-fallback-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: var(--spacing-sm);\n  padding: 6px 10px;\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: var(--radius-sm);\n  font-size: 0.7rem;\n  color: #fcd34d;\n  line-height: 1.4;\n}\n\n.ai-fallback-error-icon {\n  flex-shrink: 0;\n}\n\n.ai-fallback-error-text {\n  word-break: break-word;\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
